import SuggestedItemSeparator from 'components/form/SuggestedTimes/SuggestedItemSeparator/styled';

export default SuggestedItemSeparator;
